export default __webpack_public_path__ + "static/media/purple-vertical-bars.33ad3939.svg";